

/**
 * Counts the number of trailing zeros at the end of the decimal part of a numeric string.
 *
 * @param input The string representation of a number (e.g., "12.34000").
 * @returns The number of zeros at the end of the decimal part, or 0 if there is no decimal part or no trailing zeros.
 */
export function isgCountDecimalPlaces(input: string): number {

  if (!input)
    return 0;

  // Split the string by the decimal point
  const parts = input.split('.');

  // If there is no decimal part, return 0
  if (parts.length < 2) {
    return 0;
  }

  // Get the decimal part
  const decimalPart = parts[1];

  // Count the number of zeros at the end of the decimal part
  let zeroCount = 0;
  for (let i = decimalPart.length - 1; i >= 0; i--) {
    if (decimalPart[i] === '0') {
      zeroCount++;
    } else {
      break;
    }
  }

  return zeroCount;
}

